class SuccessionPlan {
	async getAllEmployeesSuccessionPlan(companyId, level_id, area_id, subarea_id) {
		const response = await fetch(
			`${process.env.REACT_APP_API}/career/succession/company/${companyId}?level_id=${level_id}&area_id=${area_id}&subarea_id=${subarea_id}`,
			{
				method: 'GET',
				mode: 'cors',
				headers: {
					'Content-Type': 'application/json',
				},
			}
		)
		return response.json()
	}

	async getSavePlans(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/career/succession/saved_plans/${companyId}`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	async saveActualPlan(body) {
		const response = await fetch(`${process.env.REACT_APP_API}/career/succession`, {
			method: 'POST',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		})
		return response.json()
	}

	async deletePlan(id) {
		const response = await fetch(`${process.env.REACT_APP_API}/career/succession/${id}`, {
			method: 'DELETE',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}
}
export default new SuccessionPlan()
